import classNames from 'classnames';

import css from './Skeleton.css';

interface SkeletonProps {
  className?: string;
}

/**
 * One grey placeholder block, representing loading placeholder.
 * A skeleton screen is built by composing several of them into the shape of the content being awaited.
 *
 * It fills its container's width and stands one line of text tall; anything else is a `className`
 * away, so the dimensions stay with the layout they belong to.
 *
 * Purely decorative, so it is hidden from assistive technology. Announcing the load is the
 * surface's job, and it takes two separate things (WAI-ARIA 1.2, §aria-busy and §status):
 * one `role="status"` holding visually hidden text — a live region announces its content, so a
 * name alone would not be read — plus `aria-busy` on the container of a widget whose required
 * owned elements have not arrived yet, such as a grid still missing its rows.
 */
const Skeleton = ({ className }: SkeletonProps) => {
  return <div className={classNames(css.root, className)} aria-hidden="true" />;
};

export default Skeleton;
